import React, { useMemo, useState } from 'react'

import { observer } from 'mobx-react-lite'
import { useTranslation } from 'react-i18next'

import classNames from 'classnames'
import _ from 'lodash'
import { useForm } from 'ziphy-web-shared/basic/lib/forms'
import MultiSelect from 'ziphy-web-shared/basic/lib/forms/fields/multiSelect/LegacyMultiSelect'
import { PageNoResults } from 'ziphy-web-shared/basic/lib/simple'
import { RadioTabs } from 'ziphy-web-shared/basic/lib/tabs'

import MediaPreview from '@library/media/MediaPreview'

import { apptEventsSchema } from '@ps/config/events'
import { sortEventsBy } from '@ps/helpers/events'
import { useGetMediaItems } from '@ps/library/CustomHooks'
import '@ps/library/historyTable/HistoryTable.scss'
import DocumentsTablePage from '@ps/pages/patient/tabs/documents/DocumentsTablePage'

import { $psResources } from '@store'

const ApptTabDocuments = ({ category, eventsBySubcategory }) => {
  const { t } = useTranslation()

  const categoryConfig = apptEventsSchema[category] || {}
  const [subcategory, setSubcategory] = useState(
    (_.find(categoryConfig.subcategories, (x) => x.isDefault) || {}).id,
  )
  const events = eventsBySubcategory[subcategory] || []
  const viewType = categoryConfig.subcategories[subcategory].viewType

  const { form } = useForm({
    sortBy: { value: 'date_desc', prepValue: 'singleSelect' },
  })
  const { sortBy } = form.fields

  const items = useMemo(() => {
    let result = []

    _.forEach(sortEventsBy(events, sortBy.value), (x) => {
      result.push({ event: x, resource: $psResources.getById(x.id) })
    })

    return result
  }, [events, sortBy.value]) // eslint-disable-line react-hooks/exhaustive-deps

  const subcategoryTabItems = useMemo(() => {
    let result = []
    const list = categoryConfig.subcategories

    _.forEach(_.orderBy(list, 'order', 'asc'), (x) => {
      result.push({
        id: x.id,
        text: t(x.label),
        count: _.get(eventsBySubcategory, [x.id], []).length,
      })
    })

    return result
  }, [eventsBySubcategory, category]) //eslint-disable-line react-hooks/exhaustive-deps

  const sortByItems = useMemo(() => {
    return [
      { id: 'date_desc', text: t('ps.label.sortBy.date_desc') },
      { id: 'date_asc', text: t('ps.label.sortBy.date_asc') },
    ]
  }, []) //eslint-disable-line react-hooks/exhaustive-deps

  const mediaItems = useGetMediaItems({ isLoading: false, items })

  return (
    <>
      <div className="row_wrapper mb-20">
        <div className="row row--mb-10">
          <div className="col-12 col-lg-8">
            <RadioTabs
              value={subcategory}
              setValue={(x) => setSubcategory(x)}
              items={subcategoryTabItems}
              mode="light"
            />
          </div>
          <div className="col-12 col-lg-4">
            <MultiSelect items={sortByItems} field={sortBy} mode={['sm', 'fw-400']} />
          </div>
        </div>
      </div>
      {items.length > 0 ? (
        viewType === 'gallery' ? (
          <MediaPreview items={mediaItems} />
        ) : (
          <div className="row_wrapper">
            <div className={classNames('h_table', category && 'h_table--' + category)}>
              <DocumentsTablePage pageItems={items} showRelatedAppt={false} />
            </div>
          </div>
        )
      ) : (
        <PageNoResults>{t('errors.no_results')}</PageNoResults>
      )}
    </>
  )
}

export default observer(ApptTabDocuments)
